import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL, getToken } from '../asyncConfig';

export const getAllPromotions = createAsyncThunk(
  'promotion/getAllPromotions', async (_, {rejectWithValue, fulfillWithValue}) => {
    try {
      const {data} = await axios.get(
        `${BASE_URL}/admin/promotions`,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data.promotions);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const applyPromotion = createAsyncThunk(
  'promotion/applyPromotion', async ({promo_code, user_id}, {rejectWithValue, fulfillWithValue}) => {
    try {
      const {data} = await axios.post(
        `${BASE_URL}/admin/promotions/apply`, {promo_code, user_id},
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const getPromoFulfilled = (state, action) => {
  console.log('action', action);
  state.status = '';
  state.promotions = action.payload;
}

export const getPromotionDetailsById = createAsyncThunk(
  'promotions/getPromoById', async (id, {fulfillWithValue, rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${BASE_URL}/admin/promtions/${id}`,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(res.data.vehicle);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const addPromo = createAsyncThunk(
  'promotion/add', async (details, {fulfillWithValue, rejectWithValue}) => {
    try {
      const { data } = await axios.post(
        `${BASE_URL}/admin/promotions`, details,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const getAppliedPromos = createAsyncThunk(
  'promotion/applied-promo', async (details, {fulfillWithValue, rejectWithValue}) => {
    try {
      const { data } = await axios.get(
        `${BASE_URL}/admin/promotions/applied`,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data.data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)